import React from "react";
import {withTranslate} from "react-redux-multilingual";
import DoctorCard from "./DoctorCard";
import NoData from "../NoData";
import HospitalDoctorsSearch from "./HospitalDoctorsSearch"
import {setDoctorsSkeleton} from "../../skeleton";

const HospitalDoctors = ({handelBookingFromMobile, showMoreHospitalDoctorsLoading, noMoreHospitalDoctors,showMoreHospitalDoctors,activeTab, hospitalDoctors, hospitalDoctorsIsLoading,  language, hospital, translate}) => {
    const Doctors = hospitalDoctors && hospitalDoctors.length ? hospitalDoctors.map((doctor, index) => {
            return (
                <div className="ftco-animate col-md-6 col-xs-12" key={doctor.id}>
                    <DoctorCard handelBookingFromMobile={() =>  handelBookingFromMobile()} language={language} doctor={doctor}/>
                </div>
            )
        }
    ) : (<NoData image="insurance-company"/>);
    return (
        <div hidden={activeTab === true}>
            <HospitalDoctorsSearch hospital={hospital}/>
            {
                !hospitalDoctorsIsLoading ?
                    <div>
                        <div className="row">
                            {Doctors}
                            <div className="ftco-animate col-md-2 offset-5">
                                <div className="loading-more cursor-pointer" hidden={noMoreHospitalDoctors || showMoreHospitalDoctorsLoading === true}>
                                    <div className="text-center">
                                        <a href="/"
                                           className="btn shadow-4d"
                                           onClick={(e) => showMoreHospitalDoctors(e)}>{translate("show_more")}</a>
                                    </div>
                                </div>
                                <div className="loading-more" hidden={showMoreHospitalDoctorsLoading === false}>
                                    <div className="text-center">
                                        <img style={{width: '100px'}} src="/images/loading.svg" alt="loading"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                    <div className="row">
                        {setDoctorsSkeleton(4)}
                    </div>
            }

        </div>

    )
}
export default withTranslate(HospitalDoctors)